module.exports = __webpack_public_path__ + "media/assets/images/blog/beta_features-small-7440091e11727f00c258939a87677e2d.jpg";